<template>
  <div class="brand-logo relative inline-block leading-none" :class="$attrs.class">
    <img
      src="/icons/logo-source.png"
      alt=""
      :class="[imgClass, 'brand-logo__image']"
      :fetchpriority="fetchpriority"
      draggable="false"
      decoding="async"
    >
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    imgClass: {
      type: String,
      default: 'block h-full w-full object-contain brand-logo__image',
    },
    fetchpriority: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style scoped>
/**
 * Source mark is white-on-transparent.
 * Light mode: force black. Dark mode: keep white.
 */
.brand-logo__image {
  color-scheme: only light;
  filter: brightness(0);
}

:global(html.dark) .brand-logo__image,
:global(body.dark) .brand-logo__image {
  filter: none;
}
</style>
